import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Clock, ChefHat, Users, Heart, Plus, Check } from "lucide-react";

export default function RecipeDetail({ recipe, onClose, isFav, toggleFav, addToShopping }) {
  if (!recipe) return null;
  const fav = isFav(recipe);
  const missing = recipe.ingredients_missing || [];
  return (
    <Dialog open={!!recipe} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="recipe-detail-modal" className="max-w-2xl max-h-[90vh] overflow-y-auto rounded-3xl bg-[#FDFBF7] p-6 sm:p-8">
        <div className="flex items-center gap-4 font-mono text-xs text-[#4F5D52]">
          <span className="inline-flex items-center gap-1"><Clock className="h-3.5 w-3.5" />{recipe.time_minutes} min</span>
          <span className="inline-flex items-center gap-1"><ChefHat className="h-3.5 w-3.5" />{recipe.difficulty}</span>
          <span className="inline-flex items-center gap-1"><Users className="h-3.5 w-3.5" />{recipe.servings} porz.</span>
        </div>
        <DialogTitle className="font-display text-2xl sm:text-3xl font-extrabold leading-tight">{recipe.title}</DialogTitle>
        <DialogDescription className="text-[#4F5D52]">{recipe.description}</DialogDescription>

        <button data-testid="recipe-detail-favorite-button" onClick={() => toggleFav(recipe)}
          className={`self-start inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold transition-colors ${fav ? "border-[#D95338] bg-[#FDF0ED] text-[#D95338]" : "border-[#1C241E]/15 hover:bg-white"}`}>
          <Heart className={`h-4 w-4 ${fav ? "fill-[#D95338]" : ""}`} />{fav ? "Nei preferiti" : "Salva nei preferiti"}
        </button>

        <section className="mt-2">
          <h4 className="text-xs font-semibold uppercase tracking-wider text-[#2E6F40] mb-2">Ingredienti che hai</h4>
          <ul className="space-y-1.5" data-testid="recipe-have-list">
            {(recipe.ingredients_have || []).map((i) => (
              <li key={i} className="flex items-start gap-2 text-sm"><Check className="h-4 w-4 mt-0.5 text-[#2E6F40] shrink-0" />{i}</li>
            ))}
          </ul>
        </section>

        {missing.length > 0 && (
          <section className="rounded-2xl bg-[#FDF0ED] p-4">
            <div className="flex items-center justify-between gap-3 mb-2">
              <h4 className="text-xs font-semibold uppercase tracking-wider text-[#D95338]">Ingredienti mancanti</h4>
              <button data-testid="add-to-shopping-list-button" onClick={() => addToShopping(missing)}
                className="inline-flex items-center gap-1 rounded-full bg-[#D95338] px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-[#B83E25]">
                <Plus className="h-3.5 w-3.5" />Aggiungi tutti alla spesa
              </button>
            </div>
            <ul className="space-y-1">
              {missing.map((m) => (
                <li key={m.name} className="flex items-center justify-between text-sm">
                  <span>{m.name}</span>
                  <button data-testid={`add-missing-${m.name}`} onClick={() => addToShopping([m])} aria-label={`Aggiungi ${m.name}`}
                    className="rounded-full p-1 text-[#D95338] hover:bg-white"><Plus className="h-4 w-4" /></button>
                </li>
              ))}
            </ul>
          </section>
        )}

        <section>
          <h4 className="text-xs font-semibold uppercase tracking-wider text-[#2E6F40] mb-3">Preparazione</h4>
          <ol className="space-y-4" data-testid="recipe-steps">
            {(recipe.steps || []).map((s, i) => (
              <li key={i} className="flex gap-4 text-sm leading-relaxed">
                <span className="font-display text-2xl font-bold text-[#D95338]/70 leading-none w-6 shrink-0">{i + 1}</span>
                <span>{s}</span>
              </li>
            ))}
          </ol>
        </section>
      </DialogContent>
    </Dialog>
  );
}
